export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <path d="M12 4h40l8 8v40l-8 8H12l-8-8V12z" stroke="#C9A55C" strokeWidth="2.2" />
    <path d="M24 46V18h11a8 8 0 0 1 0 16H24" stroke="#F3EEE4" strokeWidth="3" strokeLinecap="square" />
    <path d="M8 50c10-6 16-2 24-9s14-6 24-16" stroke="#C9A55C" strokeWidth="1.2" strokeLinecap="round" opacity=".8" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="nav-logo" className="flex items-center gap-3 group">
    <LogoMark className="w-9 h-9 transition-transform duration-700 group-hover:rotate-90" />
    <span className="text-left leading-none">
      <span className="font-display block text-xl tracking-wide text-[#F3EEE4]">Peci Mermer</span>
      <span className="font-mono-x block text-[10px] tracking-[0.3em] uppercase text-[#C9A55C] mt-1">Vëllezërit · Mermer & Granit</span>
    </span>
  </button>
);
